import { DataModel } from '@shared';
import { LoggingService } from '@shared/logging';
import { RxCollectionCreator } from 'rxdb';
import { WorkspaceDatabaseKeys } from '../../schemas';
import { MigrationSchemaBuilder } from '../migration-schema.builder';
import { MigrationStep } from '../migration-step.interface';

export class MigrationV2 extends MigrationStep {
	public version = 2;

	public constructor(protected loggingService: LoggingService) {
		super(loggingService);
	}

	public applyMigrationOnSchema(collectionToMigrate: RxCollectionCreator): RxCollectionCreator {
		if (!collectionToMigrate) {
			this.loggingService.error(
				'MigrationV2',
				'Please provide the collection  on which you want to apply the migration'
			);
			throw new Error('Please provide the collection on which you want to apply the migration');
		}

		if (!collectionToMigrate.migrationStrategies) {
			collectionToMigrate.migrationStrategies = {};
		}

		collectionToMigrate.migrationStrategies[this.version] = (record: DataModel) => record;

		if (
			Object.keys(collectionToMigrate.schema.properties).includes(WorkspaceDatabaseKeys.columns.depthTo) &&
			!collectionToMigrate.schema.indexes.includes(WorkspaceDatabaseKeys.columns.depthTo)
		) {
			collectionToMigrate = {
				...collectionToMigrate,
				schema: {
					...collectionToMigrate.schema,
					indexes: collectionToMigrate.schema.indexes.concat(WorkspaceDatabaseKeys.columns.depthTo)
				}
			};
		}

		if (this.shouldSkipMigration(collectionToMigrate.schema.version)) {
			if (this.hasNext()) {
				return this.getNext().applyMigrationOnSchema(collectionToMigrate);
			} else {
				return collectionToMigrate;
			}
		}

		const migratedSchema = new MigrationSchemaBuilder(collectionToMigrate.schema)
			.setSchemaVersion(this.version)
			.build();

		this.loggingService.info(
			'MigrationV2.applyMigrationOnSchema, migratedSchema version: ',
			JSON.stringify(migratedSchema.version)
		);

		collectionToMigrate = { ...collectionToMigrate, schema: migratedSchema, autoMigrate: false };

		if (this.hasNext()) {
			return this.getNext().applyMigrationOnSchema(collectionToMigrate);
		}

		return collectionToMigrate;
	}
}
